import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
	production: false,
	origin: 'https://superhog-api-dev002.azurewebsites.net/',
	assets: '/assets',
	documents: '/documents',
	uploads: '/uploads',
	acquiredUrl: 'https://qahpp.acquired.com/',
	verificationToolOrigin: 'https://verification-web-dev001.azurewebsites.net',
	verificationToolUrl: 'https://verification-web-dev001.azurewebsites.net/welcome/',
	cdnUrl: 'https://saukscdndev002.blob.core.windows.net/',
	veritasUrl: 'https://resolutions-api-dev002.azurewebsites.net/api/',
	veritasEnvironment: 'dev',
	veritasDocumentPath: 'https://sauksresdev002.blob.core.windows.net/claim-uploads/',
	oneStep: 'https://verification-web-dev001.azurewebsites.net/one-step/',
	mixpanelAnalyticsToken: '85ff0c87dc9a388d5b0538f0d4af1d85',
	cookieFirstConsentScriptSrc: 'https://consent.cookiefirst.com/sites/verification-web-dev001.azurewebsites.net-55864fc4-effb-4b37-8bc2-417d86db83e8/consent.js',
	superhogApp: 'https://superhog-web-dev001.azurewebsites.net',
	resolutionsApp: 'https://resolutions-web-dev001.azurewebsites.net/',
	intercomKey: 'inb4uw6w',
	kygUrl: 'https://kyg-web-dev001.azurewebsites.net'
};
